import * as React from 'react';

import * as styles from './styles.css';
import { ControlButton } from '../../../../../../common/components/ControlButton';
import { ZoomOut } from '../../../../../../common/components/Icons';

export interface IZoomOutButtonProps {
  map: YMaps.Map;
  onClick(): void;
}

export const ZoomOutButton: React.FC<IZoomOutButtonProps> = props => {
  const { map, onClick } = props;

  const handleZoomOutClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.preventDefault();

      onClick();

      const zoom = map.getZoom();
      const [minZoom] = map.zoomRange.getCurrent();
      if (zoom <= minZoom) {
        return;
      }

      return map.setZoom(zoom - 1);
    },
    [map, onClick],
  );

  return (
    <ControlButton className={styles['button']} onClick={handleZoomOutClick}>
      <ZoomOut />
    </ControlButton>
  );
};
